'use strict';

function resizeWindow() {
	setTimeout(function () {
		equalize();
	}, 800);
}
function scrollDown() {}

$(document).ready(function () {
	if ($('#js-countdown').length > 0) {
		//Index Countdown
		var day = $('#day').val();
		var month = $('#month').val();
		var year = $('#year').val();
		var hour = $('#hour').val();
		var minute = $('#min').val();
		var second = $('#sec').val();
		setTimeout(function () {
			$('#js-countdown').countDown({
				targetDate: {
					'day': day,
					'month': month,
					'year': year,
					'hour': hour,
					'min': minute,
					'sec': second
				},
				omitWeeks: true
			});
		}, 800);
	}
	//pop-in
	//pop-up-nav
	if ($('#home').length > 0) {
		$('.white-bar-sp').addClass('open');
		$('.pop-up-parad').delay(6000).animate({ right: '-663px' }, 500);
		setTimeout(function () {
			$('.white-bar-sp').removeClass('open');
		}, 6000);
	}

	$('#landing-testimonials .testimonials').removeClass('col-sm-8 col-sm-offset-2').addClass('col-sm-9 col-sm-offset-1');

	$('.white-bar-sp').click(function (e) {
		e.preventDefault();
		if ($(this).hasClass("open")) {
			$('.pop-up-parad').stop().animate({ right: '-663px' }, 500);
		} else {
			$('.pop-up-parad').stop().animate({ right: '0px' }, 500);
		}
		$(this).toggleClass('open');
		return false;
	});

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	setTimeout(function () {
		$('.sprite .page-view .project:nth-child(odd)').addClass('pattern');
	}, 500);

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
		var top = $(document).scrollTop();
		if (top > 20) {
			$('#header .menu-holder').addClass('scroll');
			$('.menu-text').text('Menu');
			$('.menu-holder').removeClass('close');
			$('.menu-trigger').removeClass('open');
			$('#header, #header .logo, #header .btn, #header .menu-holder, .best-rate, #primary-nav').addClass('scroll', 200);
		} else {
			$('#header, #header .logo, #header .btn, #header .menu-holder, .best-rate, #primary-nav, #header .menu-holder .menu-text').removeClass('scroll', 200);
		}
	});

	/*** tablet nav ***/
	$('.menu-trigger').click(function () {
		if ($(this).hasClass('open')) {
			$('#header, #header .logo, #header .btn, .best-rate, #primary-nav, #header .menu-holder .menu-text').removeClass('scroll', 200);
			var text = $(this).text();
			$('.menu-text').text('Menu');
			$('.menu-holder').addClass('close');
		} else {
			$('#header, #header .logo, #header .btn, .best-rate, #primary-nav, #header .menu-holder .menu-text').addClass('scroll', 200);
			var text = $(this).text();
			$('.menu-text').text('Close');
			$('.menu-holder').removeClass('close');
		}
	});
	$('.menu-trigger').click(function () {
		$(this).toggleClass('open');
	});

	$('.booking-trigger').click(function () {
		$('.booking-holder').fadeToggle();
	});
	$('.close-booking').click(function () {
		$('.booking-holder').fadeOut();
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home, .arrow-interior').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() * 2 }, 800, 'easeOutExpo');
	});

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {
		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {
		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	$('.all-specials').slick({
		arrows: true,
		dots: false,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 500,
		fade: true,
		accessibility: false,
		prevArrow: $('.prev-special'),
		nextArrow: $('.next-special')
	});

	//Hashtag smooth scroll
	if (window.location.hash) {
		setTimeout(function () {
			var hash = window.location.hash;
			$('body, html').animate({
				scrollTop: $(hash).offset().top - 70 }, 800);
		}, 500);
	}

	$('#booking-form ul li, #content .content li').wrapInner('<span></span>');

	// START Parallax Animations
	// Init ScrollMagic
	// var controller = new ScrollMagic.Controller();

	// if($('#home').length > 0) {
	// 	// Intro
	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#home .main-content .intro-content-home .top-background',
	// 	})
	// 	.setClassToggle('#home .main-content .intro-content-home .intro-copy .copy-holder, #home .main-content .intro-content-home .intro-copy .traveler', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	// Reasons
	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '.fadein-reasons',
	// 	})
	// 	.setClassToggle('#home .main-content .reasons-home .explore, #home .main-content .reasons-home h2, #home .main-content .reasons-home a.btn', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	// Specials
	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#home .main-content .reasons-home .top-background',
	// 	})
	// 	.setClassToggle('#home .main-content .specials-home .offers', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	// Gallery
	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#home .main-content .gallery-home',
	// 	})
	// 	.setClassToggle('#home .main-content .gallery-home .copy-holder', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	// Explore
	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#home .main-content .instagram h2 span',
	// 	})
	// 	.setClassToggle('#home .main-content .explore-home .copy', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);
	// }

	// if($('body.hotel-santa-fe').length > 0) {
	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .top-copy-holder h1',
	// 	})
	// 	.setClassToggle('#content .content .reasons-section h2.reasons, #content .content .spa-intro', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .top-copy .arrow-interior',
	// 	})
	// 	.setClassToggle('#content .content .reasons-section .reason-1, #content .content .reasons-section .reason-2, #content .content .reasons-section .reason-3', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .reasons-section .reason-1 .number',
	// 	})
	// 	.setClassToggle('.history-copy', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .history-section .history-copy p',
	// 	})
	// 	.setClassToggle('.spirit-copy', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .history-section .spirit-copy p',
	// 	})
	// 	.setClassToggle('#content .content .art-gallery .copy-holder', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .art-gallery .copy-holder p',
	// 	})
	// 	.setClassToggle('#content .content .amenities .amenities-copy', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .amenities ul',
	// 	})
	// 	.setClassToggle('#content .content .pet-policy .pet-copy', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);
	// }

	// if(($('body.amaya').length > 0) || ($('body.santa-fe-spa').length > 0)) {
	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .top-copy-holder p.reservations',
	// 	})
	// 	.setClassToggle('#content .content .private-dining .dining-intro', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .private-dining ul',
	// 	})
	// 	.setClassToggle('.santa-fe-spa #content .content .dining-menus .menus-top .copy-holder', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .dining-menus .menus-btm',
	// 	})
	// 	.setClassToggle('#content .content .dining-menus .menus-section', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .menus-btm ul li:last-child',
	// 	})
	// 	.setClassToggle('#content .content .dining-specials .specials-section', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .dining-specials ul li:last-of-type',
	// 	})
	// 	.setClassToggle('#content .content .pool-section .pool-side .copy-holder', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .pool-section .pool-side .copy-holder p',
	// 	})
	// 	.setClassToggle('#content .content .amenities .amenities-copy', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);
	// }

	// if($('body.meetings-events').length > 0) {
	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content p .btn.rfp-show',
	// 	})
	// 	.setClassToggle('#content .content .private-dining .dining-intro', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .dining-menus .menus-btm',
	// 	})
	// 	.setClassToggle('#content .content .dining-menus .menus-section', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .menus-btm p',
	// 	})
	// 	.setClassToggle('#content .content .dining-specials .specials-section', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .dining-specials p',
	// 	})
	// 	.setClassToggle('#content .content .amenities .amenities-copy', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .amenities ul',
	// 	})
	// 	.setClassToggle('#content .content .pet-policy .pet-copy', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);
	// }

	// if($('body.santa-fe').length > 0) {
	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .top-copy-holder .arrow-interior',
	// 	})
	// 	.setClassToggle('#content .content .private-dining .dining-intro', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .dining-menus .menus-btm',
	// 	})
	// 	.setClassToggle('#content .content .dining-menus .menus-section', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .menus-btm p',
	// 	})
	// 	.setClassToggle('#content .content .dining-specials .specials-section', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .dining-specials p',
	// 	})
	// 	.setClassToggle('#content .content .amenities .amenities-copy', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .amenities ul',
	// 	})
	// 	.setClassToggle('#content .content .pet-policy .pet-copy', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);
	// }

	// if($('body.specials').length > 0) {
	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .each-room:last-of-type .btn',
	// 	})
	// 	.setClassToggle('#content .content .reasons-section h2.reasons, #content .content .spa-intro', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);	

	// 	var sceneHeadline = new ScrollMagic.Scene({
	// 		triggerElement: '#content .content .each-room:last-of-type .btn',
	// 	})
	// 	.setClassToggle('#content .content .reasons-section .reason-1, #content .content .reasons-section .reason-2, #content .content .reasons-section .reason-3', 'fade-in')
	// 	.reverse(false)
	// 	.addTo(controller);

	// }


	$('.media-inquiry-btn').click(function () {
		$('#media-inquiry').fadeToggle();
	});
	$('.close-media-form').click(function () {
		$('#media-inquiry').fadeOut();
	});

	//Remove empty p tags with spaces or breaks
	$('p').each(function () {
		var $this = $(this);
		if ($this.html().replace(/\s|&nbsp;/g, '').length == 0) $this.remove();
	});

	$('.rfp-show').click(function () {
		$('.form-holder').slideToggle();
	});

	$('.read-more').click(function (e) {
		$(this).next('div.special-full').slideToggle();
		var text = $(this).text();
		$(this).text(text == "Terms & Conditions" ? "Terms & Conditions" : "Terms & Conditions");
	});
	$('.reservation-includes').click(function (e) {
		$(this).next('div.reservations-full').slideToggle();
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		ga('send', 'event', 'header widget', 'click', 'book now');
	});

	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		dateFormat: 'm' + '/' + 'd' + '/' + 'yy',
		altField: "#check_in_alt",
		altFormat: 'm-dd-yy',
		changeMonth: true,
		numberOfMonths: 1,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 2);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		dateFormat: 'm' + '/' + 'd' + '/' + 'yy',
		altField: "#check_out_alt",
		altFormat: 'm-dd-yy',
		changeMonth: true,
		numberOfMonths: 1,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});

	$('#s-accomodations').change(function () {
		var thisVal = $(this).val();
		$('#propertyID').val(thisVal);
	});

	// Map: Return to previous page button. Change body id to match map template's name.
	$('body#map-category #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Previous page</a>');

	$("#emailSignupGuestFolio").click(function () {
		$.post(FRONTEND_ROOT + 'ajax/guestfolio.php', $("#email-signup").serialize(), function (data) {

			if (data.error) {
				$("#email-error").html(data.msg);
			} else {
				$("#email-signup").slideUp(function () {
					$("#email-ok").show();
				});
			}
		}, 'json');
	});

	//landing page book by and promo code text 
	if ($('body.specials').length > 0) {
		//Index Countdown
		var day1 = $('.day1').val();
		var month1 = $('.month1').val();
		var year1 = $('.year1').val();
		var hour1 = $('.hour1').val();
		var minute1 = $('.min1').val();
		var second1 = $('.sec1').val();
		setTimeout(function () {
			$('.countdown-1 #countdown-1').countDown({
				targetDate: {
					'day': day1,
					'month': month1,
					'year': year1,
					'hour': hour1,
					'min': minute1,
					'sec': second1
				},
				omitWeeks: true
			});
		}, 800);
		var day2 = $('.day2').val();
		var month2 = $('.month2').val();
		var year2 = $('.year2').val();
		var hour2 = $('.hour2').val();
		var minute2 = $('.min2').val();
		var second2 = $('.sec2').val();
		setTimeout(function () {
			$('.countdown-2 #countdown-2').countDown({
				targetDate: {
					'day': day2,
					'month': month2,
					'year': year2,
					'hour': hour2,
					'min': minute2,
					'sec': second2
				},
				omitWeeks: true
			});
		}, 800);
		var day3 = $('.day3').val();
		var month3 = $('.month3').val();
		var year3 = $('.year3').val();
		var hour3 = $('.hour3').val();
		var minute3 = $('.min3').val();
		var second3 = $('.sec3').val();
		setTimeout(function () {
			$('.countdown-3 #countdown-3').countDown({
				targetDate: {
					'day': day3,
					'month': month3,
					'year': year3,
					'hour': hour3,
					'min': minute3,
					'sec': second3
				},
				omitWeeks: true
			});
		}, 800);
	}
	$("#accordion").accordion({
		active: false,
		collapsible: true
	});
});

$(window).on('load', function () {

	//Slick Slider
	$('.sym-slides').slick();
});

function getMarkerImage(iconColor) {
	if (typeof iconColor == "undefined" || iconColor == null) {
		iconColor = "red";
	}

	var icon = "pin-" + iconColor + ".png";

	var filename = $.inArray(icon, pinPointImages) >= 0 ? path + icon : iconDefault;

	if (iconColor == 'hotel') {
		var size1 = 67;
		var size2 = 65;
		filename = SITE_FILES + 'images/hotel-marker.png';
	} else {
		var size1 = 37;
		var size2 = 37;
	}

	if (!gicons[iconColor]) {
		gicons[iconColor] = new google.maps.MarkerImage(filename,
		// This marker is 20 pixels wide by 31 pixels tall.
		new google.maps.Size(size1, size2),
		// The origin for this image is 0,0.
		new google.maps.Point(0, 0),
		// The anchor for this image is at 6,20.
		new google.maps.Point(11, size2));
	}
	return gicons[iconColor];
}

function ScrollToSection(IdSection, margin) {
	if (document.getElementById(IdSection)) {
		var seccion = document.getElementById(IdSection);
		var posicion = seccion.getBoundingClientRect().top + window.scrollY - margin;
		window.scrollTo({ top: posicion, behavior: 'smooth' });
	} else {
		console.log("Id doesn't exist");
	}
}

function ConvertAnchorToId(anchor) {
	var IdSection = anchor.substring(1).toLowerCase();
	if (IdSection == "form-plan-your-event") {
		IdSection = "form_id-3242", ScrollToSection(IdSection, 200);
	}
}

document.addEventListener('DOMContentLoaded', function () {
	var anchor = window.location.hash;
	if (anchor) {
		ConvertAnchorToId(anchor);
	}
});

if (document.querySelector('#Begin_planning_form')) {
	var button = document.querySelector('#Begin_planning_form');
	button.addEventListener("click", function (e) {
		e.preventDefault();
		ScrollToSection('form_id-3242', 200);
	});
}